import XDialog from './dialog.vue';

export { XDialog };

export default {
    install (app) {
        app.component('XDialog', XDialog);
    },
};
